export const VACATION = '/vacation' as const
export const VACATION_PUBLIC_INFO = '/public/vacation-request'
